export const APP_TITLE = "五福临门";

export function getAppTitle(user) {
  const name = user && (user.username || user.nickname);
  return name ? `${APP_TITLE}-${name}` : APP_TITLE;
}

export function setAppTitle(user) {
  const title = getAppTitle(user);
  if (typeof document !== "undefined") {
    document.title = title;
  }
  return title;
}